import { Participant } from './participant';

export class ItemData {
  constructor(
    public contractNumber: string,
    public itemNumber: string,
    public to: Participant,
    public productName: string
  ) {
  }

  public static fromJSON(json: {
    contractNumber: string,
    itemNumber: string,
    to: any,
    productName?: string
  }): ItemData {
    if (!json) {
      throw new Error('ItemStatus JSON should not be undefined');
    }
    if (!json.contractNumber) {
      throw new Error('ItemData JSON should have property: contractNumber');
    }
    if (!json.itemNumber) {
      throw new Error('ItemData JSON should have property: itemNumber');
    }
    if (!json.to) {
      throw new Error('ItemData JSON should have property: to');
    }
    const participant = Participant.fromJSON(json.to);
    return new ItemData(
      json.contractNumber,
      json.itemNumber,
      participant,
      json.productName
    );
  }
}
